<template>
  <div id="page-item" :loading="loadingSelectedProduct" class="box grow scrollable only-y" v-if="product!=null">
    <resize-observer @notify="__resizeHanlder" />
    <el-tabs v-model="activeTabs" type="border-card">
      <el-tab-pane :label="overviewLabel" name="overview" v-if="product" :style="getHeightStyle" class="box grow scrollable only-y">
        <el-row >
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">
              {{$t('products.internalIdField')}}
            </span>
            <span
              class="fs-14 hidden-md-and-up">
                {{ product.puid }}
            </span>
          </el-col>
          <el-col
            :xs="16"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
            class="hidden-sm-and-down">
              <span
                class="fs-14">
                {{ product.puid }}
                </span>
          </el-col>
        </el-row>
        <el-row >
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">
              {{$t('products.productTypeField')}}
            </span>
            <span
              v-if="product.type==1"
              class="fs-14 hidden-md-and-up">
              {{$t('products.inventoryProduct')}}
            </span>
            <span
              v-else
              class="fs-14 hidden-md-and-up">
              {{$t('products.serviceProduct')}}
            </span>
          </el-col>
          <el-col
            :xs="16"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
            class="hidden-sm-and-down">
              <span
                v-if="product.type==1"
                class="fs-14">
                {{$t('products.inventoryProduct')}}
                </span>
            <span
              v-else
              class="fs-14">
              {{$t('products.serviceProduct')}}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8">
            <span class="fs-14">
              {{$t('products.inventoryField')}}
            </span>
            <span class="fs-14 hidden-md-and-up">
              {{product.inventory.name}}
            </span>
          </el-col>
          <el-col
            :xs="16"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
            class="hidden-sm-and-down">
              <span
                v-if="product.type==1"
                class="fs-14">
                  {{product.inventory.name}}
                </span>
          </el-col>
        </el-row>
        <el-row >
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">
              {{$t('products.productNameField')}}
            </span>
            <span class="fs-14 hidden-md-and-up">
              {{productName}}
              <a v-if="showExternalLink" :href="link" target="_blank" class="ml-5">
                <i class="mdi mdi-open-in-new" />
              </a>
            </span>
           
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">
              {{productName}}
              <a v-if="showExternalLink" :href="link" target="_blank" >
                <i class="mdi mdi-open-in-new" />
              </a>
            </span>
          </el-col>
        </el-row>
        <el-row v-if="isFromPrivateImport">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">
             {{$t('products.vintageAvailableField')}}
            </span>
            <span class="fs-14 hidden-md-and-up">
                {{topVintage}}
                <el-tooltip placement="top" v-if="topVintage != null">
                  <div slot="content"><span v-html="vintageAvailableTooltip"></span></div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span v-else> -- </span>
            </span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">
                {{topVintage}}
                <el-tooltip placement="top" v-if="topVintage != null">
                  <div slot="content"><span v-html="vintageAvailableTooltip"></span></div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <span v-else> -- </span>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8">
            <span class="fs-14">
              {{$t('products.providerField')}}
            </span>
            <span
              class="fs-14 hidden-md-and-up"
              v-if="product.provider">
              <el-link
                :underline="false"
                @click="openCustomer(providerId)">
                  {{providerName(product.provider)}}
                </el-link>
              </span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <PortausLink v-if="product.provider" path="/customers/" :id="providerId" :label="providerName(product.provider)"></PortausLink>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.typeSubtTypeField')}} </span>
            <span class="fs-14 hidden-md-and-up"><category :category="product.category" :specificCategory="product.specificCategory" /></span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14"><category :category="product.category" :specificCategory="product.specificCategory" /></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{ $t('products.skuField') }} </span>
            <span class="fs-14 hidden-md-and-up">{{product.sku}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.sku}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{ $t('products.externalId') }} </span>
            <span class="fs-14 hidden-md-and-up">{{product.externalId}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.externalId}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{ $t('products.shortDescriptionField') }} </span>
            <span class="fs-14 hidden-md-and-up">{{product.shortDescription}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.shortDescription}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.descriptionField')}} </span>
            <div class="fs-14 hidden-md-and-up" v-html="product.description"></div>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <div class="fs-14" v-html="product.description"></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.unitUvcField')}} </span>
            <span class="fs-14 hidden-md-and-up" v-if="product.type==1"> {{unitFormat}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14" v-if="product.type==1">{{unitFormat}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.formatField')}} </span>
            <span class="fs-14 hidden-md-and-up">{{formatLabel}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{formatLabel}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!isFromPrivateImport">
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8">
              <span
                class="fs-14"
                v-if="product.inventory.variableItemPriceInd == false">
                  {{$t('products.referencePriceField')}}
              </span>
              <span
                class="fs-14"
                v-else>
                {{$t('products.priceField')}}
              </span>
              <span
                class="fs-14 hidden-md-and-up"
                v-if="product.inventory.variableItemPriceInd == false">
                  {{$n(product.sellingUnitPrice,'currency')}}
              </span>
              <span
                class="fs-14 hidden-md-and-up"
                v-else>
                {{$n(batchAvailable.price, 'currency')}}
              </span>
          </el-col>
          <el-col
            :xs="16"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
            class="hidden-sm-and-down">
              <span
                class="fs-14"
                v-if="product.inventory.variableItemPriceInd == false">
                  {{$n(product.sellingUnitPrice,'currency')}}
              </span>
              <span
                class="fs-14"
                v-else>
                  {{$n(batchAvailable.price, 'currency')}}
              </span>
          </el-col>
        </el-row>
        <div v-else>
          <el-row v-if="product.agencyRate === null && product.agencyFee === null">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <span class="fs-14">{{$t('products.referencePriceField')}} </span>
              <span class="fs-14 hidden-md-and-up">{{$n(product.sellingUnitPrice,'currency')}}</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
              <span class="fs-14">{{$n(product.sellingUnitPrice,'currency')}}</span>
            </el-col>
          </el-row>
          <el-row >
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <span class="fs-14">{{$t('products.priceWithLicenceField')}} </span>
              <span class="fs-14 hidden-md-and-up" v-if="product.pricing != null">{{$n(licenceeAgencyPrice,'currency')}} ({{$n(product.pricing.price,'currency')}}  + {{$n(licenceeAgencyFee,'currency')}} <span v-if="licenceeAgencyRate != 'NaN'">({{licenceeAgencyRate}}%)</span>) +tx </span>
              <span v-else class="fs-14 hidden-md-and-up">{{ $t('common.notAvailable') }}</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
              <span class="fs-14"  v-if="product.pricing != null">{{$n(licenceeAgencyPrice,'currency')}} ({{$n(product.pricing.price,'currency')}}  + {{$n(licenceeAgencyFee,'currency')}} <span v-if="licenceeAgencyRate != 'NaN'">({{licenceeAgencyRate}}%)</span>) +tx</span>
              <span v-else class="fs-14">{{ $t('common.notAvailable') }}</span>
            </el-col>
          </el-row>
          
          <el-row >
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <span class="fs-14">{{$t('products.priceWithoutLicenceField')}} </span>
              <span class="fs-14 hidden-md-and-up" v-if="product.pricing != null">{{$n(particulierAgencyPrice,'currency')}} ({{$n(product.pricing.priceTaxIn,'currency')}} + {{$n(particulierAgencyFee,'currency')}}  ({{particulierAgencyRate}}%))</span>
              <span v-else class="fs-14 hidden-md-and-up">{{ $t('common.notAvailable') }}</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
              <span class="fs-14" v-if="product.pricing != null">{{$n(particulierAgencyPrice,'currency')}} ({{$n(product.pricing.priceTaxIn,'currency')}} + {{$n(particulierAgencyFee,'currency')}}  <span v-if="particulierAgencyRate != 'NaN'">({{particulierAgencyRate}}%)</span>)</span>
              <span v-else class="fs-14">{{ $t('common.notAvailable') }}</span>
            </el-col>
          </el-row>
          <el-row v-if="product.agencyRate != null || product.agencyFee != null" v-for="agencyPrice in otherAgencyPrices" :key="agencyPrice.customerClassId">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <span class="fs-14">{{$t('products.price')}} {{ getCustomerClassCode(agencyPrice.customerClassId) }} : </span>
              <span class="fs-14 hidden-md-and-up" v-if="product.pricing != null && isCustomerClassLicencie(agencyPrice.customerClassId) === false">
                {{$n(product.pricing.priceTaxIn + agencyPrice.agencyFeeWTaxes,'currency')}} ({{$n(product.pricing.priceTaxIn,'currency')}}  + {{$n(agencyPrice.agencyFeeWTaxes,'currency')}})
              </span>
              <span v-else class="fs-14 hidden-md-and-up" >{{$n(product.pricing.price + agencyPrice.agencyFee,'currency')}} ({{$n(product.pricing.price,'currency')}}  + {{$n(agencyPrice.agencyFee,'currency')}}) +tx</span>
              <span v-if="agencyPrice.agencyRate > 0 " class="fs-14 hidden-md-and-up">({{(agencyPrice.agencyRate * 100).toFixed(2)}}%)+tx</span>
              
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
              <span class="fs-14"  v-if="product.pricing != null && isCustomerClassLicencie(agencyPrice.customerClassId) === false">{{$n(product.pricing.priceTaxIn + agencyPrice.agencyFeeWTaxes,'currency')}} ({{$n(product.pricing.priceTaxIn,'currency')}}  + {{$n(agencyPrice.agencyFeeWTaxes,'currency')}}<span v-if="agencyPrice.agencyRate > 0" class="fs-14">({{(agencyPrice.agencyRate * 100).toFixed(2)}}%)</span>)</span>
              <span v-else class="fs-14" >{{$n(product.pricing.price + agencyPrice.agencyFee,'currency')}} ({{$n(product.pricing.price,'currency')}}  + {{$n(agencyPrice.agencyFee,'currency')}}<span v-if="agencyPrice.agencyRate > 0" class="fs-14">({{(agencyPrice.agencyRate * 100).toFixed(2)}}%)</span>) +tx</span>
              
             
            </el-col>
          </el-row>

          <!-- TODO À enlever ou ajouter a même les frais -->
          <!-- <el-row v-if="product.agencyRate != null  && product.inventory.code === 'IP'">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <span class="fs-14">{{$t('products.agencyFeesField')}} </span>
              <span class="fs-14 hidden-md-and-up" v-if="product.pricing != null">{{$n(product.pricing.agencyFee,'currency')}}</span>
              <span v-else class="fs-14 hidden-md-and-up">{{ $t('common.notAvailable') }}</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
              <span class="fs-14" v-if="product.pricing != null">{{$n(product.pricing.agencyFee,'currency')}} ({{(product.agencyRate * 100).toFixed(2)}}%)</span>
              <span v-else class="fs-14">{{ $t('common.notAvailable') }}</span>
            </el-col>
          </el-row> -->
        </div>
        <el-divider />
        <h4>{{$t('products.details.qty')}}</h4>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14" v-if="product.inventory.code === 'IP'">
            {{$t('products.details.qty_available_inventory_SAQ')}}
            </span>
            <span class="fs-14" v-else>
              {{$t('products.details.qty_available_inventory')}}
            </span>
            <span class="fs-14 hidden-md-and-up" >{{product.quantity.onHand}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14" >{{product.quantity.onHand}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_on_order')}}</span>
              <span class="fs-14 hidden-md-and-up">{{product.quantity.confirmed}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.quantity.confirmed}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_reserved')}}</span>
            <span class="fs-14 hidden-md-and-up">{{product.quantity.reserved}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.quantity.reserved}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_available')}}</span>
            <span class="fs-14 hidden-md-and-up" v-if="product.quantity.inStock>0">{{product.quantity.inStock}}</span>
            <span class="fs-14 hidden-md-and-up" v-else>0</span>
            <span v-if="product.quantity.pending!=null && product.quantity.pending>0" class="fs-14 hidden-md-and-up"> <i class="el-icon-right"></i>{{product.quantity.pending - product.quantity.reservedDelayed}} <el-tooltip class="item" effect="dark" content="Qte disponible / Qte en approvisionnement" placement="top-start"><i class="el-icon-question"></i></el-tooltip></span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14" v-if="product.quantity.inStock>0">{{product.quantity.inStock}}</span>
            <span class="fs-14" v-else>0</span>
            <span v-if="product.quantity.pending!=null && product.quantity.pending>0" class="fs-14"> <i class="el-icon-right"></i>{{product.quantity.pending - product.quantity.reservedDelayed}} <el-tooltip class="item" effect="dark" content="Qte disponible / Qte en approvisionnement" placement="top-start"><i class="el-icon-question"></i></el-tooltip></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_reserved_on_next_batch')}}</span>
            <span class="fs-14 hidden-md-and-up">{{product.quantity.reservedDelayed}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.quantity.reservedDelayed}}</span>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_reserved_intention')}}</span>
            <span class="fs-14 hidden-md-and-up">{{product.quantity.reservedIntention}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.quantity.reservedIntention}}</span>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14">{{$t('products.details.qty_ordered')}}</span>
              <span class="fs-14 hidden-md-and-up">{{product.quantity.ordered}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14">{{product.quantity.ordered}}</span>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <span class="fs-14">{{$t('products.details.available_batches')}}</span>

        <AvailableBatch
          v-if="product.inventory"
          :edit="editItem"
          :selectedProductItemsLeft="selectedProductItems"
          :inventoryProductDelayLimit="product.inventory.productDelayLimit"
          :inventoryProductDelay="product.inventory.productDelay"
          :inventoryId="productInventoryId"
          :showEndDelay="isPrivateImport"
          @edit="v => $emit('editItem', v)" />

       <el-divider></el-divider>
       <span class="fs-14">{{$t('products.details.purchase_orders_waiting')}}</span>
       <div class="hidden-lg-and-up">
         <el-card v-for="po in waitingPurchaseOrders" :key="po.id" shadow="never" style="margin-top:10px;">
           <span class="fs-14 secondary-text">{{$t('products.details.poNumber')}} {{po.po_number}}</span><br>
           <span class="fs-14 secondary-text">{{$t('products.details.quantity')}} {{po.qty_to_receive}}</span><br>
           <span class="fs-14 secondary-text">{{$t('products.details.reference')}} {{po.reference}}</span><br>
           <span class="fs-14 secondary-text">{{$t('products.details.releaseDate')}} {{moment(po.reception_planning_date, 'll')}}</span>
         </el-card>
       </div>
       <el-table
          :data="waitingPurchaseOrders"
          stripe
          :empty-text="$t('products.details.no_purchase_orders')"
          style="width: 100%"
          c-loading="loadingSelectedProductPurchaseOrders"
          class="hidden-md-and-down">
          <el-table-column
            :label="$t('products.details.po')">
              <template slot-scope="scope">
                <PortausLink :path="'/inventories/' + productInventoryId+'/purchase-orders/'" :id="scope.row.id" :label="scope.row.po_number"></PortausLink>
              </template>
          </el-table-column>
          <el-table-column
            :label="$t('products.referenceNumber')">
           <template slot-scope="scope">
             <span>{{scope.row.reference}}</span>
           </template>
          </el-table-column>
          <el-table-column
            :label="$t('products.shortAdditionnalInformation')">
           <template slot-scope="scope">
             <span>{{getVintage(scope.row.extraInfo)}}</span>
             <el-link
                v-if="scope.row.productItem != null"
                :underline="false"
                @click="showTechnicalSheet(scope.row.productItem.id)">
                <i class="mdi mdi-book-open ml-5" />
              </el-link>
           </template>
          </el-table-column>
          <el-table-column
            width="80"
            :label="$t('products.qty')">
            <template slot-scope="scope">
              <span>{{scope.row.qty_to_receive}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('products.receptionDate')">
              <template slot-scope="scope">
                 <span v-if="scope.row.reception_planning_date != null">{{moment(scope.row.reception_planning_date, 'l')}}</span>
                 <span v-else>{{$t('NA')}}</span>
              </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="technicalSheetLabel" :lazy="true" name="technical" v-if="product" :style="getHeightStyle" class="box grow scrollable only-y">

          <TechnicalSheet :id="this.technicalSheetId" :image="thubmnailImage"/>

      </el-tab-pane>
      <el-tab-pane v-if="!isThirdPartyIventory" :label="ordersLabel" :lazy="true" name="sales" :style="getHeightStyle" class="box grow scrollable only-y">
        <SalesItemTable :puid="puid" :productName="productName"/>
      </el-tab-pane>
      <el-tab-pane v-if="!isThirdPartyIventory" :label="reservationsLabel" name="reservation" :style="getHeightStyle" :lazy="true" class="box grow scrollable only-y">
        <ReservationTable :puid="puid" :showProductName="false" :showFilters="true"></ReservationTable>
      </el-tab-pane>
      <el-tab-pane :label="adjustmentsLabel" name="third" :lazy="true" :style="getHeightStyle" class="box grow scrollable only-y">
        <el-row class="m-10" v-if="!showAdjustmentForm">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <span class="fs-14" v-if="product.inventory.code === 'IP'">
              {{$t('products.SAQInventoryQuantityField')}}
            </span>
            <span class="fs-14" v-else>
              {{$t('products.inStockQuantityField')}}
            </span>
            <span class="fs-14 hidden-md-and-up" >{{product.quantity.onHand}}</span>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="hidden-sm-and-down">
            <span class="fs-14" >{{product.quantity.onHand}}</span>
          </el-col>
        </el-row>
        <el-collapse v-model="adjustmentCollpase" class="m-10" v-if="!showAdjustmentForm">
          <el-collapse-item title="Lot(s) disponible(s)" name="availableBatch">
            <AvailableBatch class="m-20" :selectedProductItemsLeft="selectedProductItems" :inventoryProductDelayLimit="product.inventory.productDelayLimit" :inventoryProductDelay="product.inventory.productDelay" :inventoryId="productInventoryId"></AvailableBatch>
          </el-collapse-item>
        </el-collapse>
        <div class="m-10">
          <span class="fs-14 mt-20">{{$t('adjustments.adjustmentsTitle')}} </span>
          <el-button icon="el-icon-s-operation" @click="handleAdjustInventory" size="small" style="float:right;" :disabled="!$can('manage','Inventories')">{{$t('adjustments.adjustButton')}}</el-button>
          <InventoryAdjustmentForm class="mt-20" v-if="showAdjustmentForm" :product="product" :inventoryId="productInventoryId" :productItems="selectedProductItems" @close="closeAdjustmentForm" @adjusted="handleAdjustment"></InventoryAdjustmentForm>
          <AdjustmentTable v-if="product && !showAdjustmentForm" :puid="puid" @deleted="updateSelectedProduct" ></AdjustmentTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- product Detail END -->
    <TechnicalSheetDrawer
      :visible="technicalSheetDrawerVisible"
      :id="selectedTechnicalSheetId"
      @close="closeTechnicalSheet"/>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import AvailableBatch from './available-batch'
import InventoryAdjustmentForm from '@/components/adjustment/inventory-adjustment-form'
import ReservationTable from '@/components/reservation/reservation-table-standalone'
import PortausLink from '@/components/portaus-link'
import ProductUtil from '@/utils/product-util'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'
import CustomerUtil from '@/utils/customer-util'
import SalesItemTable from '@/components/salesOrder/sales-item-table'
import TechnicalSheet from './technical-sheet'
import Category from '@/components/product/category-txt';
import TechnicalSheetDrawer from './technical-sheet-drawer'
export default {
  name: 'Inventory-Product-Detail-Info',
  props: {
		product : {type : Object},
    productItems : [],
    inventoryId : {type : Number},
    height : {type : Number},
    editItem : {type : Boolean, default:true}
	},
  data() {
    return {
      activeTabs : 'overview',
      adjustmentCollpase : '',
      sales : [],
      window: {
        width: 0,
        height: 0
      },
      showAdjustmentForm : false,
      technicalSheetDrawerVisible: false,
      selectedTechnicalSheetId: null,
    };
  },components: {
    'AdjustmentTable': () => import('@/components/adjustment/adjustment-table'),
    AvailableBatch,
    InventoryAdjustmentForm,
    ReservationTable,
    PortausLink,
    SalesOrderStatusTag,
    SalesItemTable,
    TechnicalSheet,
    Category,
    TechnicalSheetDrawer,
  },
  watch : {
    product : function(val){
      this.handleAdjustInventory(false);
    }
  },
	methods: {
    showTechnicalSheet (id) {
      this.selectedTechnicalSheetId = id;
      this.technicalSheetDrawerVisible = true;
    },
    closeTechnicalSheet () {
      this.selectedTechnicalSheetId = null;
      this.technicalSheetDrawerVisible = false;
    },
    getVintage (extraInfo) {
      return _.get(extraInfo, 'vintage');
    },
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usualName);
    },
    getCustomerClassCode (customerClassId) {
      return _.lowerCase(_.get(this.getCustomerClassById(customerClassId), 'code'));
    },
    isCustomerClassLicencie (customerClassId) {
      return _.upperCase(_.get(this.getCustomerClassById(customerClassId), 'ind')) === 'LICENCIE';
    },
    handleAdjustment(){
      this.refreshSelectedProduct();
    },
    closeAdjustmentForm(){
      this.showAdjustmentForm = false;
    },
    handleAdjustInventory(open = true){
      this.showAdjustmentForm = open;
      let initParams = {};
      if(this.product!=null){
        initParams.onProduct = true;
        initParams.product = this.product;
        initParams.productItems  = this.product.items;
        initParams.inventoryId = this.product.inventoryId;
      }
      this.initAdjustment(initParams);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    __resizeHanlder: _.throttle(function (e) {
			this.handleResize();
		}, 700),
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    getTagTypeBasedOnStatus(status){
      if(status == null) return null;
      if(status.id==1){
        return "info"
      }else if(status.id==2){
        return ""
      }else if(status.id==3){
        return "danger"
      }else  if(status.id==4){
        return "success"
      }else if (status.id==5){
        return "warning"
      }else {
        return "success"
      }
    },
    openPO(purchaseOrderId){
      var index='/inventories/'+this.product.inventoryId+'/purchase-orders/'+purchaseOrderId;
      this.$router.push(index);
    },
    momentAdd(datetime, nbDays){
      return moment(datetime).add(nbDays,'days').format('LL');
    },
    moment(datetime, format){
			return  moment(datetime).format(format);
		},
    ...mapActions('inventoryProducts',['updateSelectedProduct','refreshSelectedProduct']),
    ...mapActions('inventoryAdjustmentEditor',[ 'initAdjustment']),
    ...mapActions('controlData', ['fetchCustomerClasses']),


	},
	computed: {
    otherAgencyPrices () {
  
      const patriculierCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'PARTICULIER');
      const licenceeCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'LICENCEE');
      

      const agencyPrices = _.filter(_.get(this.product, 'pricing.pricesByClasses'), pricesByClass => pricesByClass.customerClassId !== _.get(patriculierCustomerClass, 'id') && pricesByClass.customerClassId !== licenceeCustomerClass.id)
      return agencyPrices;
    },
    licenceeAgencyRate () {
      const licenceeCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'LICENCEE');
      const agencyFeeByCustomerClass = _.find(_.get(this.product, 'pricing.pricesByClasses'), priceByClass => priceByClass.customerClassId === _.get(licenceeCustomerClass, 'id'));
      let agencyRate = _.get(this.product, 'agencyRate');
      
      if (agencyRate == null && agencyFeeByCustomerClass == null) {
        const agencyFee = _.get(this.product, 'pricing.agencyFee');
        agencyRate = agencyFee /  _.get(this.product, 'pricing.price');
        return (agencyRate * 100).toFixed(2);
      }
      
      if (licenceeCustomerClass != null) {
          
          if (agencyFeeByCustomerClass != null) {
            if (agencyFeeByCustomerClass.agencyFee > 0) {
              return 'NaN'
            }
            agencyRate = agencyFeeByCustomerClass.agencyRate;
          }
        }
      return (agencyRate * 100).toFixed(2);
    },
    licenceeAgencyFee () {
      let agencyFee = _.get(this.product, 'pricing.agencyFee');
      const licenceeCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'LICENCEE');
      if (licenceeCustomerClass != null) {
          const agencyFeeByCustomerClass = _.find(_.get(this.product, 'pricing.pricesByClasses'), priceByClass => priceByClass.customerClassId === _.get(licenceeCustomerClass, 'id'));
          if (agencyFeeByCustomerClass != null) {
            agencyFee = agencyFeeByCustomerClass.agencyFee;
          }
        }
      return agencyFee;
    },
    licenceeAgencyPrice () {
      if (this.product.pricing != null) {
       
        return this.product.pricing.price + this.licenceeAgencyFee;
      }
      return null;
    },
    particulierAgencyFee () {
      let agencyFee = _.get(this.product, 'pricing.agencyFeeBasedOnTaxInWTaxes');
      
      if (_.get(this.product, 'agencyRate') != null || _.get(this.product, 'agencyFee') != null) {
        agencyFee = _.get(this.product, 'pricing.agencyFeeWTaxes');
      } 

      const patriculierCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'PARTICULIER');
      if (patriculierCustomerClass != null) {
          const agencyFeeByCustomerClass = _.find(_.get(this.product, 'pricing.pricesByClasses'), priceByClass => priceByClass.customerClassId === _.get(patriculierCustomerClass, 'id'));
          if (agencyFeeByCustomerClass != null) {
            agencyFee = agencyFeeByCustomerClass.agencyFeeWTaxes;
          }
        }
      return agencyFee;
    },
    particulierAgencyRate () {
      let agencyRate = _.get(this.product, 'agencyRate');
      if (agencyRate == null) {
        const agencyFee = _.get(this.product, 'pricing.agencyFeeBasedOnTaxIn');
        agencyRate = agencyFee /  _.get(this.product, 'pricing.priceTaxIn');
        return (agencyRate * 100).toFixed(2);
      }
      const patriculierCustomerClass = _.find(this.customerClasses, cc => cc.ind_agency_type === 'PARTICULIER');
      if (patriculierCustomerClass != null) {
          const agencyFeeByCustomerClass = _.find(_.get(this.product, 'pricing.pricesByClasses'), priceByClass => priceByClass.customerClassId === _.get(patriculierCustomerClass, 'id'));
          if (agencyFeeByCustomerClass != null) {
            agencyRate = agencyFeeByCustomerClass.agencyRate;
          }
        }
      return (agencyRate * 100).toFixed(2);
    },
    particulierAgencyPrice () {
      if (this.product.pricing != null) {
       
        return this.product.pricing.priceTaxIn + this.particulierAgencyFee;
      }
      return null;
    },
    showExternalLink () {
      return this.isThirdPartyIventory;
    },
    link (){
      return `https://app.datagrapes.io/products/${this.productExternalId}/synthesis`;
    },
    productExternalId (){
      return _.get(this.product, 'externalId');
    },
    isThirdPartyIventory () {
      return _.get(this.product, 'inventory.code') === 'SAQ';
    },
    isPrivateImport () {
      return _.get(this.product, 'inventory.code') === 'IP';
    },
    thubmnailImage () {
      return _.get(this.product, 'image.thumbnailLink');
    },
    overviewLabel () {
      return this.$i18n.t('products.details.overview');
    },
    technicalSheetLabel () {
      return this.$i18n.t('products.details.technicalSheetLabel');
    },
    ordersLabel () {
      return this.$i18n.t('products.details.orders');
    },
    reservationsLabel () {
      return this.$i18n.t('products.details.reservations');
    },
    adjustmentsLabel () {
      return this.$i18n.t('products.details.adjustment');
    },
    technicalSheetId (){
      if ((_.get(this.product, 'item') != null && _.get(this.product, 'item.quantity.onHand') > 0) || 
      _.get(this.product, 'item') != null && _.get(this.product, 'itemToCome') == null) {
        return _.get(this.product, 'item.productItem.id');
      }
      let lastItem = _.last(this.product.items);
      if (lastItem == null) {
        // On va voir dans les bons de commandes
        lastItem = _.get(this.product, 'itemToCome');
      }
     return _.get(lastItem, 'productItem.id');
      
    },
    productInventoryId () {
      return _.get(this.product, 'inventory.id');
    },
    vintageAvailableTooltip(){
      return this.$i18n.t('products.vintageAvailableTooltip');
    },
    productName(){
      if (this.isFromPrivateImport)
        return ProductUtil.getSimpleProductName(this.product);
      else {
        return ProductUtil.getExtendedProductName(this.product);
      }

    },
    topVintage(){
      if (_.get(this.product, 'quantity.inStock') > 0 && _.get(this.product, 'item.extraInfo.vintage') != null){
        return _.get(this.product, 'item.extraInfo.vintage');
      } else if (_.get(this.product, 'quantity.pending') > 0 && this.waitingTopVintage != null) {
        return this.waitingTopVintage;
      } else if (!_.isEmpty(this.product.items)) {
        return this.lastVintage;
      }
      return null;
    },
    lastVintage () {
      const lastItem = _.last(this.product.items);
      return _.get(lastItem, 'extraInfo.vintage');
    },
    waitingTopVintage () {
      return _.get(_.head(this.waitingPurchaseOrders), 'extraInfo.vintage');
    },
    isFromPrivateImport () {
      if (this.productInventoryId == null) return false;
      let inventory = this.getInventory(this.productInventoryId);
      return _.get(inventory, 'code') === 'IP';
    },
    formatLabel(){
      return ProductUtil.getFormatLabel(_.get(this.product, 'volume'), _.get(this.product, 'format'));
    },
    unitFormat(){
      return ProductUtil.getUnitFormatLabel(_.get(this.product, 'unit'), _.get(this.product, 'uvc'));
    },
    providerId () {
      return _.get(this.product, 'provider.id');
    },
    productId () {
      return _.get(this.product, 'id');
    },
    puid(){
      return _.get(this.product, 'puid');
    },
    getHeightStyle(){
      let h = this.height==null ? (this.window.height-330) : this.height-80
      return "height:" + h + "px;";
    },
    batchAvailable(){
      let prices = {
        price  : null,
        priceTaxIn : null
      };
      return _.get(this.product, 'pricing') != null ? _.get(this.product, 'pricing') : prices;
    },
    ...mapState('inventoryProducts', ['products','inventory', 'selectedProduct','selectedProductItems','selectedProductPurchaseOrders','loadingSelectedProductItems','loadingSelectedProductPurchaseOrders','loadingSelectedProduct']),
    ...mapGetters('inventoryProducts',['waitingPurchaseOrders', 'isNegative','isPositive','isIntermediary','providerName', 'getSelectedProductAvailableBatch','getSelectedProductItemsOnHandQuantity']),
    ...mapGetters('inventory', ['getInventory']),
    ...mapState('controlData', ['customerClasses']),
    ...mapGetters('controlData', ['getCustomerClassById'])
	},
  mounted(){
    this.fetchCustomerClasses();
  },
	created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
	},destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.el-collapse-item{
  font-size:14px;
}

.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}


.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}


@media (max-width: 1024px) {

}
</style>
